import React from "react";
import styled from "styled-components";
import MenuIcon from "@material-ui/icons/Menu";
import { CircleButton } from "@sonder/ui/source/styled/fragments/CircleButton";
import { HeaderBar } from "@sonder/ui/source/styled/fragments/HeaderBar";
import { TopBar } from "@sonder/ui/source/styled/fragments/Sidebar";
import { Header } from "@sonder/ui/source/styled/layouts/Header";
import { colors } from "@sonder/ui/source/styled/theme";
import { useLayout } from "core/components/LayoutProvider";

const PageTitle = styled.h1`
  color: ${colors.gray4};
  font-size: 1.5rem;
  margin: 0;
`;

const MenuButton = styled(CircleButton)`
  margin-left: -0.5rem;
  padding: 0 0.5rem;
`;

interface AppHeaderProps {
  children?: React.ReactNode;
  title: string;
}
export const AppHeader = ({ children, title }: AppHeaderProps) => {
  const { sidebar, setSidebar } = useLayout();
  return (
    <Header>
      <TopBar>
        <MenuButton
          backgroundVariant="dark"
          onClick={() =>
            setSidebar(sidebar === "collapsed" ? "expanded" : "collapsed")
          }
        >
          <MenuIcon />
        </MenuButton>
      </TopBar>
      <HeaderBar>
        <PageTitle data-cy="PageTitle">{title}</PageTitle>
      </HeaderBar>
      {children}
    </Header>
  );
};
